export const API_URL = 'https://api-guru.e-so.in';
//export const API_URL = 'http://localhost:8000';

// Dual API configuration for download from live, upload to local
export const LIVE_API_URL = 'https://api-guru.e-so.in';
export const LOCAL_API_URL = 'http://localhost:8000';